import { z } from "zod/v4";
import { internationalRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface InternationalParams {
	season?: number;
	tour?: string;
	limit?: number;
}

export const international = {
	list: (params: InternationalParams = {}) => {
		const query = new URLSearchParams();
		if (params.season != null) query.set("season", String(params.season));
		if (params.tour) query.set("tour", params.tour);
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/international${qs ? `?${qs}` : ""}`, z.array(internationalRowSchema));
	},
};
